import { ImageUpload } from '#assets/svg';
import isVideo from '#utils/isVideo';
import { useEffect, useState } from 'react';
import { FileUpload } from 'src/shared/components/file-upload/FileUpload';
import { Tooltip } from 'src/shared/components/tooltip/Tooltip';
import { useDraftChartForEdit } from '../Edit/useDraftChartForEdit';
import { Key } from '../MemberInfo/components/styles';
import { useBeforeAfterPhotoState } from '../states/beforeAfterPhotoState';

export const BeforeAfterPhoto = () => {
  const maxCountMsg = '전후 비교사진은 최대 1장까지 첨부할 수 있어요!';

  const { setBeforeAfterPhoto } = useBeforeAfterPhotoState();

  const onUploadFileComplete = (id: string) => {
    setBeforeAfterPhoto(prev => [...prev, id]);
  };

  const onRemoveFileComplete = (id: string) => {
    setBeforeAfterPhoto(prev => prev.filter(fileId => fileId !== id));

    setDefaultFileInfo(undefined);
  };

  const [defaultFileInfo, setDefaultFileInfo] = useState<
    | {
        id: string;
        url: string;
        type: 'videos' | 'images';
      }
    | undefined
  >(undefined);

  const { draftChart } = useDraftChartForEdit();

  useEffect(() => {
    if (draftChart && draftChart.beforeAfterPhoto) {
      setBeforeAfterPhoto([draftChart.beforeAfterPhoto[0].id]);

      if (draftChart.beforeAfterPhoto.length > 0) {
        setDefaultFileInfo({
          id: draftChart.beforeAfterPhoto[0].id,
          url: draftChart.beforeAfterPhoto[0].resizedLink,
          type: isVideo(draftChart.beforeAfterPhoto[0].resizedLink)
            ? 'videos'
            : 'images'
        });
      }
    }
  }, [draftChart]);

  return (
    <div className="flex items-center justify-between pt-12 flex-wrap">
      <div className="flex gap-4 items-center ">
        <Key>전후 비교 사진</Key>
        <Tooltip
          tooltipTrigger={
            <img
              src="/images/help-24-dp-5-f-6368-fill-1-wght-400-grad-0-opsz-241.svg"
              width={'16px'}
              height={'16px'}
            />
          }
          position="top-center"
        >
          <div style={{ width: '183px' }}>
            <div
              style={{
                color: 'var(--gray-15---main-font, #EAE8ED)',
                fontFamily: '"Pretendard Variable"',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '16px',
                textAlign: 'left'
              }}
            >
              전후 비교 사진이란?
            </div>
            <div
              style={{
                color: 'var(--gray-100---sub-font, #8E899F)',
                fontFamily: '"Pretendard Variable"',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '16px',
                textAlign: 'left'
              }}
            >
              트레이너의 수업을 받기 전과 후를 비교할 수 있는 사진입니다. 같은
              배경과 구도로 찍을 경우 비교하기 편해요!
            </div>
          </div>
        </Tooltip>
      </div>

      <FileUpload
        maxCount={1}
        maxCountMsg={maxCountMsg}
        fileType={'image/*'}
        path={'image'}
        onUploadFileComplete={onUploadFileComplete}
        onDeleteFileComplete={onRemoveFileComplete}
        defaultFileInfoList={defaultFileInfo ? [defaultFileInfo] : undefined}
      >
        <ImageUpload />
      </FileUpload>
    </div>
  );
};
